import { render, staticRenderFns } from "./SettingEdit.vue?vue&type=template&id=77a545d0"
import script from "../../controllers/setting/setting-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/setting/setting-edit.js?vue&type=script&lang=js&external"
import style0 from "./SettingEdit.vue?vue&type=style&index=0&id=77a545d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports